// Import model
import { StartLeadTakeSnapshotRequest } from '../models/StartLeadTakeSnapshotRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadTakeSnapshotRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadTakeSnapshotRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadTakeSnapshotRequest instance
   */
  static deserialize(json: string): StartLeadTakeSnapshotRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadTakeSnapshotRequest instance
   */
  static fromObject(obj: any): StartLeadTakeSnapshotRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadTakeSnapshotRequest');
    }


    const instance: StartLeadTakeSnapshotRequest = {
      name: obj['Name'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadTakeSnapshotRequest instances
   */
  static deserializeArray(json: string): StartLeadTakeSnapshotRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadTakeSnapshotRequest instance to a JSON string
   */
  static serialize(instance: StartLeadTakeSnapshotRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadTakeSnapshotRequest instance to a plain object
   */
  static toObject(instance: StartLeadTakeSnapshotRequest): any {
    return {
      'Name': instance.name,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartLeadTakeSnapshotRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadTakeSnapshotRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
